// extracted by mini-css-extract-plugin
export default {"handler":"styles_handler__QBTzX","visible":"styles_visible__J1L-q","hidden":"styles_hidden__YCb29","dnd-element":"styles_dnd-element__Dwuu4"};